var communitySettingsNavigationConfig = [
    {
        id: 'profile',
        title: 'Основное',
        handle: 'profile'
    },
    {
        id: 'participation',
        title: 'Управление участниками',
        handle: 'participation'
    },
    {
        id: 'telegram',
        title: 'Телеграм бот',
        handle: 'telegram'
    },
    {
        id: 'activity',
        title: 'Тренировки',
        handle: 'activity'
    },
    {
        id: 'delete',
        title: 'Удаление сообщества',
        handle: 'delete-community'
    },
];
export default communitySettingsNavigationConfig;
